import {useHistoryStoragesWithMaterialQuery} from '@domain/material-storage'
import {useMaterialsRecipesById} from '@domain/materials'
import type {OperationModeSnapshot} from '@hconnect/common/types'
import {useUpmPlantContext} from '@hconnect/upm'
import {useMemo} from 'react'

import {getStoragesWithMaterialForOperationMode} from '../../../selectors'
import type {MomentRange} from '../../../types'

export const useAvailableStoragesForOperationMode = (
  activeOperationMode: OperationModeSnapshot,
  timeFrame: MomentRange
) => {
  const {plantId} = useUpmPlantContext()
  const {data: recipesById} = useMaterialsRecipesById({plantId})
  if (!recipesById) {
    throw new Error('BUG: recipesById query should be loaded before rendering this hook')
  }
  const {data: storagesWithMaterial} = useHistoryStoragesWithMaterialQuery({plantId, timeFrame})
  if (!storagesWithMaterial) {
    throw new Error('BUG: storagesWithMaterial query should be loaded before rendering this hook')
  }
  return useMemo(() => {
    const availableStorages = getStoragesWithMaterialForOperationMode(
      recipesById,
      storagesWithMaterial,
      activeOperationMode
    )
    return availableStorages
  }, [recipesById, activeOperationMode, storagesWithMaterial])
}
